<template>
  <gg-card>
    <gg-card-text class="pa-3 kvm-ssh-wrap">
      <kvm-ssh-keys :entitlement-id="server.id" server />
    </gg-card-text>
  </gg-card>
</template>

<script>
import KvmSshKeys from '@/views/services/hosting/kvm/KvmSshKeys'

export default {
  name: 'HostingKvmSsh',
  components: { KvmSshKeys },
  props: {
    // Provided by KvmServiceView via <router-view :server :loading>.
    server: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style scoped lang="scss">
@import './kvm-ui';

// Reclaim horizontal room for the keys table on small screens (320px / 200% zoom).
@media (max-width: $kvm-bp-mobile) {
  .kvm-ssh-wrap {
    padding: 8px !important;
  }
}
</style>
